import { CAREER_HUB_BASE_PATH, Head } from '@xing-com/crate-career-hub-common';
import { HeaderNavigation } from '@xing-com/crate-career-hub-header-navigation';
import { LoggedOutFooter } from '@xing-com/crate-career-hub-logged-out-footer';
import { IconArrowRight } from '@xing-com/icons';
import { Section, Container } from '@xing-com/layout-primitives';

import { CardsData } from './cards-data';
import { Styled } from './category-page.styles';
import {
  TOPIC_DATA_SEO,
  TITLE,
  INTRODUCTORY_TEXT,
  BUTTON_TEXT,
} from './constants';
import { TopicCard } from './topic-card';

const topicPage = 'bewerbungUebersicht';
export const CategoryPage: React.FC = () => {
  const { title: seoTitle, description: seoDescription } =
    TOPIC_DATA_SEO[topicPage] || {};

  return (
    <Section noBlockPadding>
      <Container>
        <Head
          titleTranslationKey={seoTitle}
          descriptionTranslationKey={seoDescription}
        />
        <HeaderNavigation {...{ title: 'Bewerbung' }} />
        <Styled.Hero size="small">{TITLE}</Styled.Hero>
        <Styled.BodyCopy size="large">{INTRODUCTORY_TEXT}</Styled.BodyCopy>
        <Styled.TextButton
          data-qa="career-hub-more-button"
          to={`${CAREER_HUB_BASE_PATH}/bewerbung?sc_o=career_hub_application_evergreen_article_click&sc_o_PropActionOrigin=career_hub_application_overview`}
          icon={IconArrowRight}
          iconAfter
        >
          {BUTTON_TEXT}
        </Styled.TextButton>
        {CardsData.map((cardData) => (
          <TopicCard
            title={cardData.title}
            slug={cardData.slug}
            articles={cardData.articles}
            key={cardData.title}
          />
        ))}
        <LoggedOutFooter topicKey="overview" />
      </Container>
    </Section>
  );
};
